import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { Observable, Subscription } from 'rxjs';

import {
  selectIsLoadingMetrics,
  selectMetricsLoaded,
  selectUnanswered,
} from '../../../../state/metrics/metrics.selectors';
import { UnansweredQuestion } from '../../../../../models/unanswered-question';
import { Study } from '../../../../../models/study';
import { AppState } from '../../../../../state';

@Component({
  selector: 'dashboard-unanswered-metrics-preview',
  templateUrl: './unanswered-metrics-preview.component.html',
  styleUrls: ['./unanswered-metrics-preview.component.scss'],
})
export class UnansweredMetricsPreviewComponent implements OnInit, OnDestroy {
  @Input() selectedStudy: Study;

  loadingMetrics$: Observable<boolean>;
  metricsLoaded$: Observable<boolean>;

  unansweredQuestions: UnansweredQuestion[];

  selectedUnansweredQuestion: UnansweredQuestion;

  columnsToDisplay = ['count', 'name', 'question'];

  private subscriptions = new Subscription();

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loadingMetrics$ = this.store.select(selectIsLoadingMetrics);
    this.metricsLoaded$ = this.store.select(selectMetricsLoaded);

    this.subscriptions.add(
      this.store
        .select(selectUnanswered)
        .subscribe((unansweredQuestions) => (this.unansweredQuestions = unansweredQuestions))
    );
  }

  setSelectedUnansweredQuestion(unansweredQuestion: UnansweredQuestion): void {
    this.selectedUnansweredQuestion = unansweredQuestion;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
